import { Component, OnInit, Input, AfterViewInit, inject } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { FormGroup, FormControl } from '@angular/forms';
import * as _ from 'underscore';
import { ConfirmationService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@devinforius/i-essentials';
import { OAuthUserInfos } from 'src/app/shared/models/oAuthUserInfo';
import { PersonalParams, PersonalParamsParams } from 'src/app/shared/models/iCourrier/me/personal-params';
import { MeService } from 'src/app/shared/services/me.service';
import { Box } from 'src/app/shared/models/iCourrier/box/box';
import { SsoService } from '@devinforius/i-sso';

@Component({
  selector: 'app-super-box-list-custom',
  templateUrl: './super-box-list.component.html',
  styleUrls: ['./sass/super-box-list.component.scss', './sass/basic.scss'],
})
export class SuperBoxListCustomComponent implements OnInit, AfterViewInit {
  private confirmationService = inject(ConfirmationService);
  public toastr = inject(ToastrService);
  private translater = inject(TranslateService);
  private ssoService = inject(SsoService);
  private meService = inject(MeService);


  public myBoxes: Box[][] = [];
  public initBoxes: Box[][] = [];
  public openModal: boolean = false;
  public indexes: string[] = [];
  public editMode: boolean = false;
  public fct: (params?) => void;
  public boxesIndex: Box[][] = [];
  public filterForm = new FormGroup({
    Title: new FormControl<string>(null),
  });
  @Input() dragEnabled: boolean;
  @Input() set boxArray(value: Box[][]) {
    this.myBoxes = value;
    this.initBoxes = value;
  }
  @Input() events;

  ngOnInit(): void {
    if (localStorage.getItem('iCourrierBoxes') && sessionStorage.getItem('reloadDashboard') !== '1') {
      this.boxesIndex = JSON.parse(localStorage.getItem('iCourrierBoxes'));
      this.boxesIndex.map((item) => {
        this.myBoxes.map((box) => {
          box.map((b) => {
            item.map((it) => {
              if (it.title === b.title) {
                it.click = b.click;
                it.count = b.count;
              }
            });
          });
        });
      });
    } else {
      this.myBoxes.map((item) => {
        item.map((it, index) => {
          it.index = index;
        });
      });
      this.boxesIndex = this.myBoxes;
      localStorage.setItem('iCourrierBoxes', JSON.stringify(this.boxesIndex));
      sessionStorage.removeItem('reloadDashboard');
    }
    this.indexes = this.myBoxes.map((x, i) => 'list_box_' + i);
  }

  ngAfterViewInit(): void {
    if (localStorage.getItem('iCourrierBoxes')) {
      this.boxesIndex = JSON.parse(localStorage.getItem('iCourrierBoxes'));
      this.boxesIndex.map((item) => {
        this.myBoxes.map((box) => {
          box.map((b) => {
            item.map((it) => {
              if (it.title === b.title) {
                it.click = b.click;
                it.count = b.count;
              }
            });
          });
        });
      });
    } else {
      this.myBoxes.map((item) => {
        item.map((it, index) => {
          it.index = index;
        });
      });
      this.boxesIndex = this.myBoxes;
      localStorage.setItem('iCourrierBoxes', JSON.stringify(this.boxesIndex));
    }

    this.indexes = this.myBoxes.map((x, i) => 'list_box_' + i);
  }

  public reinit(): void {
    this.myBoxes = this.initBoxes;
    this.save();
  }

  public save(): void {
    const userInfo = this.ssoService.tokenPayload() as unknown as OAuthUserInfos;

    this.meService.getMyPersonalParams('CourrierFavoris').subscribe({
      next: (res: PersonalParams[]) => {
        if (res.length > 0) {
          const data: PersonalParamsParams = {
            value: JSON.stringify(this.boxesIndex[0]),
            description: res[0].description,
            name: res[0].name,
          };
          this.meService.putMyPersonalParams(res[0].id, 'CourrierFavoris', data).subscribe({
            next: () => this.toastr.success(this.translater.translate('homeCourrier.fav.saved')),
          });
        } else {
          const data: PersonalParamsParams = {
            value: JSON.stringify(this.boxesIndex[0]),
            hideInDashboard: false,
            name: 'Fav' + userInfo.family_name,
            description: 'Favoris de ' + userInfo.name,
            shared: false,
          };
          this.meService.postMyPersonalParams('CourrierFavoris', data).subscribe({
            next: () => this.toastr.success(this.translater.translate('homeCourrier.fav.saved')),
          });
        }
      },
    });

    localStorage.setItem('iCourrierBoxes', JSON.stringify(this.boxesIndex));
    this.ngOnInit();
  }

  getHeight(items: Array<Box>): number {
    return 39 * items.length;
  }

  getOthers(i): string[] {
    return this.indexes.filter((x) => x !== 'list_box_' + i);
  }

  drop(items: Box[], event: CdkDragDrop<Box[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(items, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, items, event.previousIndex, event.currentIndex);
    }
  }

  submit(): void {
    const last = _.last(this.myBoxes);
    last.push({ title: this.filterForm.value.Title });
    this.save();
    this.openModal = false;
    this.filterForm.value.Title = null;
  }

  delete(title: string): void {
    this.confirmationService.confirm({
      message: this.translater.translate('homeCourrier.superBox.doYouwantToREmoveFilter'),
      accept: () => {
        this.myBoxes.map((boxes) => {
          boxes.filter((box, index) => {
            if (box.title === title) {
              return boxes.splice(index);
            }
          });
        });
        this.save();
      },
      reject: () => {
        return null;
      },
    });
  }
  public function(box, fct: (params) => void, event): void {
    if (!this.editMode) {
      fct(event);
    }
  }

  changeBoxHideState(event, box): void {
    box.hideFromPersonalDashboard = event.checked;
  }

  deleteSaveSearch(box): void {
    this.confirmationService.confirm({
      message: this.translater.translate('homeCourrier.savedSearch.areYouSure', { boxTitle: box.title }),
      accept: () => {
        this.meService.deletePersonalParams(box.id, 'CourrierRechercheSauvegardee').subscribe({
          next: () => {
            this.toastr.success(this.translater.translate('homeCourrier.savedSearch.wellDone'));
            sessionStorage.setItem('reloadDashboard', '1');
            this.boxesIndex[2] = this.boxesIndex[2].filter((x) => x.id !== box.id);
            localStorage.setItem('iCourrierBoxes', JSON.stringify(this.boxesIndex));
          },
        });
      },
      reject: () => {
        return null;
      },
    });
  }
}
